"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M16.03 19H3l4.5-7L3 5h13.03L21 12zM6.5 17H15l3.5-5L15 7H6.5l3.5 5z"
}), 'LabelImportantOutlineSharp');